import { Dispatch } from '@reduxjs/toolkit'
import { TickmillCompanyDto } from 'api/Identity/Types/Company'
import { BonusLabel } from 'api/Wallet/Types/BonusCampaignTypes'
import { UpdateWalletTradingAccountTransfer } from 'api/Wallet/Types/UpdateWalletTradingAccountTransfer'
import { WalletCurrencyDto } from 'api/Wallet/Types/WalletCurrencyDto'
import { Toast } from 'components/Toast/Toast'
import { WalletsApiClient } from 'utils/api/walletsApiClient'

import { walletSlice } from './wallet.slice'

export const getWalletStatesAction = (walletsApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getWalletState()
      dispatch(walletSlice.actions.setWalletStates(response))
    } catch (e) {
      console.error('Error during get wallet states', e)
    }
  }
}

export const getWalletPaymentProvidersActions = (walletsApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getWalletPaymentProviders()
      dispatch(walletSlice.actions.setWalletPaymentProviders(response))
    } catch (e) {
      console.error('Error during get wallet payment providers', e)
    }
  }
}

export const getWalletRestrictionsAction = (walletsApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getWalletRestrictions()
      dispatch(walletSlice.actions.setWalletRestrictions(response))
    } catch (e) {
      console.error('Error during get wallet restrictions', e)
    }
  }
}

export const getWalletTypesByClientIdAction = (
  clientId: string,
  walletsApiClient: WalletsApiClient
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getWalletTypesByClientId(clientId)
      dispatch(walletSlice.actions.setClientWalletTypes(response))
    } catch (e) {
      console.error('Error during get wallet types', e)
    }
  }
}

export const getWalletTypesAction = (walletsApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getWalletTypes()
      dispatch(walletSlice.actions.setWalletTypes(response))
    } catch (e) {
      console.error('Error during get wallet types', e)
    }
  }
}

export const getSocialMediaTypesAction = (walletsApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getSocialMediaTypes()
      dispatch(walletSlice.actions.setSocialMediaTypes(response))
    } catch (e) {
      console.error('Error during get wallet social media types', e)
    }
  }
}

export const getWalletCurrenciesAction = (walletsApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getWalletCurrencies()
      dispatch(walletSlice.actions.setWalletCurrencies(response))
    } catch (e) {
      console.error('Error during get wallet types', e)
    }
  }
}

export const updateWalletToToTradingAccountAction = (
  walletsApiClient: WalletsApiClient,
  data: UpdateWalletTradingAccountTransfer,
  typeId: number,
  setToast: (toast: Toast) => void
) => {
  return async (): Promise<void> => {
    try {
      await walletsApiClient.updateWalletToTradingAccountTransfer(data, typeId)
      setToast({
        type: 'success',
        title: `Transfer has been submitted.`,
      })
    } catch (e) {
      console.error('Error during create update to trading account transaction', e)
    }
  }
}

export const getAllowedBonusTypesAction = (walletsApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getAllowedBonusTypes()
      dispatch(walletSlice.actions.setBonusTypes(response))
    } catch (e) {
      console.error('Error during get bonus types', e)
    }
  }
}

export const fetchWalletCurrenciesByCompanyAction = (
  walletsApiClient: WalletsApiClient,
  tickmillCompanies: TickmillCompanyDto[]
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const currenciesByCompanyId: Record<number, WalletCurrencyDto[]> = {}
      await Promise.all(
        tickmillCompanies.map(async ({ id }) => {
          currenciesByCompanyId[id] = await walletsApiClient.getWalletAvailableCurrencies(id)
        })
      )
      dispatch(walletSlice.actions.setWalletCurrenciesByCompany(currenciesByCompanyId))
    } catch (e) {
      console.error('Error when fetching wallet currencies', e)
    }
  }
}
export const fetchBonusLabelsAction = (walletApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const bonusLabels: BonusLabel[] = await walletApiClient.getBonusLabels()
      dispatch(walletSlice.actions.setBonusLabels(bonusLabels))
    } catch (error) {
      console.error('Error during get bonus labels', error)
    }
  }
}

export const fetchBonusCampaignExcludeTypesAction = (walletApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletApiClient.getBonusCampaignExcludeTypes()
      dispatch(walletSlice.actions.setBonusCampaignExcludeTypes(response))
    } catch (error) {
      console.error('Error fetching bonus campaign exclude types', error)
    }
  }
}

export const fetchBonusAvailabilityPeriodsAction = (walletsApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getBonusCampaignAvailabilityPeriods()
      dispatch(walletSlice.actions.setBonusCampaignAvailabinilityPeriods(response))
    } catch (error) {
      console.error('Error fetching bonus availability periods', error)
    }
  }
}

export const fetchBonusCampaignCountdownTriggersAction = (walletsApiClient: WalletsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await walletsApiClient.getBonusCampaignCountdownTriggers()
      dispatch(walletSlice.actions.setBonusCampaignCountdownTriggers(response))
    } catch (error) {
      console.error('Error fetching bonus campaign countdown triggers', error)
    }
  }
}
